// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div.half.textaligncenter>img{margin:0 auto}.half.whitebox.youtube{margin-top:40px;margin-bottom:0}@media screen and (min-width:900px){.half.extraspace,.half.whitebox.youtube{width:44%;margin:0 5% 0 0}.half.last.extraspace,.half.last.whitebox.youtube{width:44%;margin:0 0 0 5%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
